import { createFileRoute } from "@tanstack/react-router";
import Contact from "@/pages/Contact";
import { contactHead } from "@/lib/route-seo";

export const Route = createFileRoute("/contact")({
  head: () => contactHead(),
  component: Contact,
});
